<template>
  <div>

    <div class="v-header clearfix" >
      <div class="Top">
        <div class="w_mar clearfix"> 
            <span class="fl">欢迎来到江苏金赛德供应链管理有限公司</span>
            <span class="fr encnBg" style="color:#000;padding: 0px 20px;">
              <a href="http://www.sedalink.com/" style="color:#333;">&nbsp;中文&nbsp;</a>|
              <a href="http://www.sedalink.com/en" style="color:#333;">English&nbsp;</a>
            </span>
       </div>
      </div>
     <div class="w_logo_c ">
        <div class="w_mar clearfix w_logo">
           <router-link to="/" tag="a" class="logo" style="float:left;margin-top: 5px;cursor: pointer">
              <img src="../../assets/logo.png" alt="江苏金赛德供应链" height="50">
            </router-link>
            <div style="float: right;" class="w_service">
                <i class="el-icon-phone-outline" style="font-size: 50px;margin-right: 14px;margin-top: 6px;color:rgb(255, 208, 75); "></i>
                <div style="float: right;">
                  <p >服务专线</p>
                  <p style="color: #822887;font-size: 34px;font-weight: bold;">0512-57001598</p>
                </div>
            </div>
        </div>
     </div>
    <!--  <div style="clear: both;"></div> -->
       <div style="background:#822887">
        <div class="pcrender w_mar" >
          <el-menu :default-active="activeIndex2" class="el-menu-demo" :mode="horizontal" @select="handleSelect"
            background-color="#822887" text-color="#fff" active-text-color="rgb(255, 208, 75)" style="margin: 0 auto;">

            <el-menu-item index="1">
              <router-link to="/" tag="a" style="display:block;width:100%;">首页</router-link>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title"><router-link to="/about/0">关于金赛德</router-link></template>
              <el-menu-item index="2-1">
                <router-link to="/about/0" style="display:block;width:100%;" class="w_font">企业简介</router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link to="/about/1" style="display:block;width:100%;"  class="w_font">企业成长</router-link>
              </el-menu-item>
              <el-menu-item index="2-3">
                <router-link to="/about/2" style="display:block;width:100%;"  class="w_font">企业文化</router-link>
              </el-menu-item>
              <el-menu-item index="2-4">
                <router-link to="/about/3" style="display:block;width:100%;"  class="w_font">组织架构</router-link>
              </el-menu-item>
              <el-menu-item index="2-5">
                <router-link to="/about/4" style="display:block;width:100%;"  class="w_font">服务优势</router-link>
              </el-menu-item>
              <el-menu-item index="2-6">
                <router-link to="/about/5" style="display:block;width:100%;"  class="w_font">海外代理</router-link>
              </el-menu-item>
              <el-menu-item index="2-7">
                <router-link to="/about/6" style="display:block;width:100%;"  class="w_font">资质证书</router-link>
              </el-menu-item>
              <el-menu-item index="2-8">
                <router-link to="/about/7" style="display:block;width:100%;"  class="w_font">合作客户</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title"><router-link to="/logistics/0">国际物流专线</router-link></template>
              <el-menu-item index="3-1">
                <router-link to="/logistics/0" style="display:block;width:100%;"  class="w_font">尼日利亚专线</router-link>
              </el-menu-item>
              
            </el-submenu>
            <el-submenu index="4">
              <template slot="title"><router-link to="/business/0">业务板块</router-link> </template>
              <el-menu-item index="4-1">
                <router-link to="/business/0" style="display:block;width:100%;"  class="w_font">国际物流</router-link>
              </el-menu-item>
              <el-menu-item index="4-2">
                <router-link to="/business/1" style="display:block;width:100%;"  class="w_font">国际贸易</router-link>
              </el-menu-item>
              <el-menu-item index="4-3">
                <router-link to="/business/2" style="display:block;width:100%;"  class="w_font">供应链管理</router-link>
              </el-menu-item>
              <el-menu-item index="4-4">
                <router-link to="/business/3" style="display:block;width:100%;"  class="w_font">供应链融资</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title"><router-link to="/solve/0">解决方案</router-link> </template>
              <el-menu-item index="5-1">
                <router-link to="/solve/0" style="display:block;width:100%;"  class="w_font">电子</router-link>
              </el-menu-item>
              <el-menu-item index="5-2">
                <router-link to="/solve/1" style="display:block;width:100%;"  class="w_font">工程</router-link>
              </el-menu-item>
              <el-menu-item index="5-3">
                <router-link to="/solve/2" style="display:block;width:100%;"  class="w_font">化工</router-link>
              </el-menu-item>
              <el-menu-item index="5-4">
                <router-link to="/solve/3" style="display:block;width:100%;"  class="w_font">汽车</router-link>
              </el-menu-item>
              <el-menu-item index="5-5">
                <router-link to="/solve/4" style="display:block;width:100%;"  class="w_font">冷链</router-link>
              </el-menu-item>
              <el-menu-item index="5-6">
                <router-link to="/solve/5" style="display:block;width:100%;"  class="w_font">木材</router-link>
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="6"><router-link to="/case">成功案例</router-link></el-menu-item>
            <el-submenu index="7">
              <template slot="title"><router-link to="/fnews/0">新闻资讯</router-link></template>
              <el-menu-item index="7-1">
                <router-link to="/fnews/0" style="display:block;width:100%;"  class="w_font">公司新闻</router-link>
              </el-menu-item>
              <el-menu-item index="7-2">
                <router-link to="/fnews/1" style="display:block;width:100%;"  class="w_font">行业动态</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="8">
              <template slot="title"><router-link to="/recruit/0">招贤纳士</router-link></template>
              <el-menu-item index="8-1">
                <router-link to="/recruit/0" style="display:block;width:100%;"  class="w_font">人才理念</router-link>
              </el-menu-item>
              <el-menu-item index="8-2">
                <router-link to="/recruit/1" style="display:block;width:100%;"  class="w_font">福利待遇</router-link>
              </el-menu-item>
              <el-menu-item index="8-3">
                <router-link to="/recruit/2" style="display:block;width:100%;"  class="w_font">培训成才</router-link>
              </el-menu-item>
              <el-menu-item index="8-4">
                <router-link to="/recruit/3" style="display:block;width:100%;"  class="w_font">职位信息</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="9">
              <template slot="title"><router-link to="/contactUs/0">联系我们</router-link></template>
              <el-menu-item index="9-1">
                <router-link to="/contactUs/0" style="display:block;width:100%;"  class="w_font">联系方式</router-link>
              </el-menu-item>
              <el-menu-item index="9-2">
                <router-link to="/contactUs/1" style="display:block;width:100%;"  class="w_font">服务网点</router-link>
              </el-menu-item>
              <el-menu-item index="9-3">
                <router-link to="/contactUs/2" style="display:block;width:100%;"  class="w_font">分支机构</router-link>
              </el-menu-item>
            </el-submenu>
             <el-menu-item index="10"><a href="http://m.sedalink.com/search" target="_blank">运价查询</a></el-menu-item>
          </el-menu>
           
        </div>
      </div>
      <div style="color:#fff;line-height:60px;" class="mbrender" @click="mbRender()"><i class="el-icon-more" style="color: #000"></i></div>
      <div class="mrender_detail" ref="mrender_detail" v-show="show">
         <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="vertical" @select="mbhandleSelect"
          background-color="#545c64" text-color="#fff" active-text-color="rgb(255, 208, 75)" style="float:left;width:100%;">

           <el-menu-item index="1">
              <router-link to="/" tag="a" style="display:block;width:100%;">首页</router-link>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title"><router-link to="/about/0">关于金赛德</router-link></template>
              <el-menu-item index="2-1">
                <router-link to="/about/0" style="display:block;width:100%;" class="w_font">企业简介</router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link to="/about/1" style="display:block;width:100%;"  class="w_font">企业成长</router-link>
              </el-menu-item>
              <el-menu-item index="2-3">
                <router-link to="/about/2" style="display:block;width:100%;"  class="w_font">企业文化</router-link>
              </el-menu-item>
              <el-menu-item index="2-4">
                <router-link to="/about/3" style="display:block;width:100%;"  class="w_font">组织架构</router-link>
              </el-menu-item>
              <el-menu-item index="2-5">
                <router-link to="/about/4" style="display:block;width:100%;"  class="w_font">服务优势</router-link>
              </el-menu-item>
              <el-menu-item index="2-6">
                <router-link to="/about/5" style="display:block;width:100%;"  class="w_font">海外代理</router-link>
              </el-menu-item>
              <el-menu-item index="2-7">
                <router-link to="/about/6" style="display:block;width:100%;"  class="w_font">资质证书</router-link>
              </el-menu-item>
              <el-menu-item index="2-8">
                <router-link to="/about/7" style="display:block;width:100%;"  class="w_font">合作客户</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title"><router-link to="/logistics/0">国际物流专线</router-link></template>
              <el-menu-item index="3-1">
                <router-link to="/logistics/0" style="display:block;width:100%;"  class="w_font">尼日利亚专线</router-link>
              </el-menu-item>
              
            </el-submenu>
            <el-submenu index="4">
              <template slot="title"><router-link to="/business/0">业务板块</router-link> </template>
              <el-menu-item index="4-1">
                <router-link to="/business/0" style="display:block;width:100%;"  class="w_font">国际物流</router-link>
              </el-menu-item>
              <el-menu-item index="4-2">
                <router-link to="/business/1" style="display:block;width:100%;"  class="w_font">国际贸易</router-link>
              </el-menu-item>
              <el-menu-item index="4-3">
                <router-link to="/business/2" style="display:block;width:100%;"  class="w_font">供应链管理</router-link>
              </el-menu-item>
              <el-menu-item index="4-4">
                <router-link to="/business/3" style="display:block;width:100%;"  class="w_font">供应链融资</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title"><router-link to="/solve/0">解决方案</router-link> </template>
              <el-menu-item index="5-1">
                <router-link to="/solve/0" style="display:block;width:100%;"  class="w_font">电子</router-link>
              </el-menu-item>
              <el-menu-item index="5-2">
                <router-link to="/solve/1" style="display:block;width:100%;"  class="w_font">工程</router-link>
              </el-menu-item>
              <el-menu-item index="5-3">
                <router-link to="/solve/2" style="display:block;width:100%;"  class="w_font">化工</router-link>
              </el-menu-item>
              <el-menu-item index="5-4">
                <router-link to="/solve/3" style="display:block;width:100%;"  class="w_font">汽车</router-link>
              </el-menu-item>
              <el-menu-item index="5-5">
                <router-link to="/solve/4" style="display:block;width:100%;"  class="w_font">冷链</router-link>
              </el-menu-item>
              <el-menu-item index="5-6">
                <router-link to="/solve/5" style="display:block;width:100%;"  class="w_font">木材</router-link>
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="6"><router-link to="/case">成功案例</router-link></el-menu-item>
            <el-submenu index="7">
              <template slot="title"><router-link to="/fnews/0">新闻资讯</router-link></template>
              <el-menu-item index="7-1">
                <router-link to="/fnews/0" style="display:block;width:100%;"  class="w_font">公司新闻</router-link>
              </el-menu-item>
              <el-menu-item index="7-2">
                <router-link to="/fnews/1" style="display:block;width:100%;"  class="w_font">行业动态</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="8">
              <template slot="title"><router-link to="/recruit/0">招贤纳士</router-link></template>
              <el-menu-item index="8-1">
                <router-link to="/recruit/0" style="display:block;width:100%;"  class="w_font">人才理念</router-link>
              </el-menu-item>
              <el-menu-item index="8-2">
                <router-link to="/recruit/1" style="display:block;width:100%;"  class="w_font">福利待遇</router-link>
              </el-menu-item>
              <el-menu-item index="8-3">
                <router-link to="/recruit/2" style="display:block;width:100%;"  class="w_font">培训成才</router-link>
              </el-menu-item>
              <el-menu-item index="8-4">
                <router-link to="/recruit/3" style="display:block;width:100%;"  class="w_font">职位信息</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="9">
              <template slot="title"><router-link to="/contactUs/0">联系我们</router-link></template>
              <el-menu-item index="9-1">
                <router-link to="/contactUs/0" style="display:block;width:100%;"  class="w_font">联系方式</router-link>
              </el-menu-item>
              <el-menu-item index="9-2">
                <router-link to="/contactUs/1" style="display:block;width:100%;"  class="w_font">服务网点</router-link>
              </el-menu-item>
              <el-menu-item index="9-3">
                <router-link to="/contactUs/2" style="display:block;width:100%;"  class="w_font">分支机构</router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
      
        activeIndex2: '1',
        horizontal:'horizontal' , //设置导航条水平方向
        show:false  //控制导航条显示或隐藏
      };
    },
    mounted:function(){
      var activeIndex =localStorage.getItem('active')
      this.activeIndex2 = activeIndex

    },
    methods: {
      handleSelect(key, keyPath) {
        if (key == '5') {
          this.$router.push({
            path: '/case'
          })
        }
        this.$emit('activeKey',key) //当前访问的路由
      },  
      mbRender(){
        this.show = !this.show
      },
      mbhandleSelect(){
        if(this.show){
            this.show =false
        }
      }
    },
    watch: {
      '$route'(to, from) {
        if(/\//.test(to.path)){ 
          this.activeIndex2 = "1"
        }
        // 对路由变化作出响应...
        if(/about/.test(to.path)){
          this.activeIndex2 = "2-1"
        }
         if(/logistics/.test(to.path)){
          this.activeIndex2 = '3-1'
        }
          if(/business/.test(to.path)){
          this.activeIndex2 = "4-1"
        }
          if(/solve/.test(to.path)){
          this.activeIndex2 = "5-1"
        }
          if(/fnews/.test(to.path)){
          this.activeIndex2 = "6-1"
        }
          if(/recruit/.test(to.path)){
          this.activeIndex2 = "8-1"
        }
          if(/contactUs/.test(to.path)){
          this.activeIndex2 = "9-1"
        }
      }
    }
  }

</script>

<style scope>
.encnBg{
   background-image: url("~@/assets/t2.png");
    background-repeat: no-repeat;
      background-position: 0px 3px;
}
.w_logo_c{
  height: 60px;
  background: #fff;
  margin-top: 1px;
padding: 25px 0px;
}
.Top{
      height: 30px;
    background: #fff;
    line-height: 30px;
}
  .v-header {
   /* position: fixed;
    top: 0px;
    width: 100%;
    z-index: 999;
    background: rgb(246, 246, 246);*/
  }

  .logo {
    padding: 0px 20px;
    margin-right: 100px;
  }

  .router-link-active {
    color: rgb(255, 208, 75);
  }

  .el-menu.el-menu--horizontal {
    border: none;
  }
 .mbrender{
   color: rgb(255, 255, 255);
    line-height: 60px;
    float: right;
    margin-right: 35px;
    font-size: 18px;
    display: none;
 }
 .mrender_detail{
   position: absolute;
    width: 100%;
   right: 0px;
    top: 61px;
      z-index: 99;
 }
 /* 响应式布局 */
 @media screen and (max-width:768px) {
   .v-header .pcrender{
     display: none;
   }
   .v-header .mbrender{
     display: block;
   }
   .v-header .w_service{
      display: none;
   }
   .v-header .Top {
    display: none;
   }
  .v-header .w_logo_c {
    float: left;
  }
  div.v-header{
    background-color: #fff;
  }
  .v-header .w_logo_c{
    padding: 0px;
  }
 
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue